export const updateQueryStringReplace = (window: Window, query: string) => {
  const trimmedQuery = query.trim();
  if (query.trim() !== '') {
    window.history.replaceState(null, '', `${window.location.pathname}?${trimmedQuery}`);
  } else {
    window.history.replaceState(null, '', window.location.pathname);
  }
};

export const updateQueryStringPush = (window: Window, query: string) => {
  const trimmedQuery = query.trim();
  if (trimmedQuery !== '') {
    window.history.pushState(null, '', `${window.location.pathname}?${trimmedQuery}`);
  } else {
    window.history.pushState(null, '', window.location.pathname);
  }
};

export const navigateToEmberApp = (baseUrl: string, memberId: string, publicKey: string) => {
  const token = btoa(`${publicKey}:${memberId}`);
  navigateToEmberAppWithToken(baseUrl, token);
};

export const navigateToEmberAppWithToken = (baseUrl: string, token: string) => {
  if (baseUrl.charAt(baseUrl.length - 1) === '/') {
    const withoutSlash = baseUrl.substring(0, baseUrl.length - 1);
    window.location.assign(`${withoutSlash}?authorize=${token}`);
  } else {
    window.location.assign(`${baseUrl}?authorize=${token}`);
  }
};
